import { useNavigate } from "@/router";
import { Path } from "@/router";
import ActionCard from "@/components/ActionCard";
import TabLayout from "../_TabLayout";
import usePageTitle from "@/hooks/usePageTitle";
import { MaterialNames } from "@/components/material_symbol_names";
import SectionHeading from "@/components/SectionHeading";

export default function DuesManagementPage() {
  usePageTitle("/billing/dues-management", "Billing | Dues Management");
  const navigate = useNavigate();

  const actionCards = [
    {
      title: "Manage Products",
      description: "Add or update the products that are added to Dues orders, including pricing",
      iconName: "box",
      actionFn: () => navigate("/billing/dues-management/manage-products" as Path)
    },

    {
      title: "Manage Suspensions and Terminations",
      description: "View, suspend, or terminate people who are eligible because of unpaid Dues",
      iconName: "group_off",
      actionFn: () => navigate("/billing/dues-management/suspensions-and-terminations" as Path)
    },
    {
      title: "View Reporting",
      description: "View reports of unbilled people and unpaid Dues to identify billing gaps or upcoming suspensions",
      iconName: "monitoring",
      actionFn: () => navigate("/billing/dues-management/reporting" as Path)
    }
  ];

  return (
    <TabLayout>
      <SectionHeading body="Manage dues rates, suspensions, and terminations, and view reporting for billing" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[90rem]">
        {actionCards.map((card) => (
          <div key={card.title}>
            <ActionCard
              actionFn={card.actionFn}
              iconName={card.iconName as MaterialNames}
              text={card.description}
              title={card.title}
            />
          </div>
        ))}
      </div>
    </TabLayout>
  );
}
